module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter1"
  }, [_c('strong', [_vm._v("About This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Note that the dates given are often the dates of discovery, but in other instances they indicate the year in which a discovery or concept gained wide acceptance in the scientific community. Benzene, to pick one example, had been known for decades before 1865, but that’s when its real structure was first worked out—a discovery that set off many others in turn. Many discoveries do not have precise origins, being spread out over a wide time frame (or among many different people). Spider silk was first analyzed chemically in 1907, but even after over a century of work by untold numbers of chemists, we still don’t quite understand how it does what it does. In some cases I picked another landmark as the year, such as the date a Nobel Prize was awarded or other large development was made. For instance, chemical reactions that can take carbon dioxide out of the air (on a small scale) have been known since the 1800s, but a dramatic practical example of this knowledge came when this technique saved the lives of the Apollo 13 astronauts in 1970. On a larger scale, the amount of carbon dioxide in the atmosphere has been a huge topic over the last twenty-five years, but the “greenhouse effect” was first understood back in 1896. You may be surprised at how early (or how late) some discoveries show up.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7519e9dd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/fm1.vue
// module id = 75
// module chunks = 0